<div class="vitamui-header">
  <div class="vitamui-container">
    <h2>
      {{ 'SELECT_TENANT.MY_TENANTS' | translate }}
    </h2>
  </div>
</div>

<vitamui-common-tenant-select-content [tenants]="tenants"></vitamui-common-tenant-select-content>
